import { render } from "./TorneioCartaz.vue?vue&type=template&id=5f2bbf26&scoped=true"
import script from "./TorneioCartaz.vue?vue&type=script&lang=js"
export * from "./TorneioCartaz.vue?vue&type=script&lang=js"

import "./TorneioCartaz.vue?vue&type=style&index=0&id=5f2bbf26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2bbf26"]])

export default __exports__